import { Component, computed, effect, ElementRef, inject, input, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { FormContentComponent } from '../form-content/form-content.component';
import { Industry, OptionItem, StepContent } from 'matchmaking/models';
import { FormOptionComponent } from '../form-option/form-option.component';
import {
    MatchmakingApiService,
    MatchmakingDataService,
    MatchmakingTranslateService,
    TrackingMatchmakingSnowplowService
} from 'matchmaking/services';
import { FormSubmitButtonComponent } from '../form-submit-button/form-submit-button.component';
import { FormOptionListComponent } from '../form-option-list/form-option-list.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'matchmaking-step-industry',
    imports: [
    FormContentComponent,
    FormOptionComponent,
    FormSubmitButtonComponent,
    FormOptionListComponent,
    FormsModule,
    TranslateModule
],
    templateUrl: './step-industry.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './step-industry.component.scss'
})
export class StepIndustryComponent implements OnInit {
    translationService = inject(MatchmakingTranslateService);
    apiService = inject(MatchmakingApiService);
    dataService = inject(MatchmakingDataService);
    trackingService = inject(TrackingMatchmakingSnowplowService);

    content = input.required<StepContent>();
    textAreaElementElementRef = viewChild.required<ElementRef>('textAreaElement');

    translations = computed(() => this.translationService.translations());
    options = computed(() => this.dataService.content()?.industries);
    customIndustryText = computed(() => this.dataService.config()?.customIndustryText);
    showTextField = computed(() => this.selectedOption() == Industry.Other);
    selectedOption = computed(() => this.dataService.getSelectedIndustry()?.externalId);
    isDisabled = computed(() => {
        const isOther = this.showTextField();
        const isTextAreaEmpty = this.customIndustryText() === '';
        const isOptionSelected = Boolean(this.selectedOption());
        const disabled = (isOther && isTextAreaEmpty) || !isOptionSelected;

        return disabled;
    });


    constructor(
    ) {
        effect(() => {
            if (this.showTextField()) {
                requestAnimationFrame(() => {
                    this.textAreaElementElementRef()?.nativeElement.focus();
                });
            }
        });
    }

    ngOnInit() {
        const config = this.dataService.config();
        if (config) {
            this.trackingService.trackStepStart({ step_number: 1, step_name: config.currentStep });
        }
    }

    setSelected(option: OptionItem) {
        this.dataService.updateConfig({ selectedIndustry: this.dataService.getIndustryById(option.title) });
    }

    setCustomIndustryText(value: string) {
        this.dataService.updateConfig({ customIndustryText: value });
    }

    submit() {
        this.apiService.submit();
    }
}
